var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 4.04729C1.66699 3.6528 1.98679 3.33301 2.38128 3.33301H17.6194C18.0139 3.33301 18.3337 3.6528 18.3337 4.04729C18.3337 4.44178 18.0139 4.76158 17.6194 4.76158H2.38128C1.98679 4.76158 1.66699 4.44178 1.66699 4.04729ZM1.66699 7.85682C1.66699 7.46233 1.98679 7.14253 2.38128 7.14253H17.6194C18.0139 7.14253 18.3337 7.46233 18.3337 7.85682C18.3337 8.25131 18.0139 8.5711 17.6194 8.5711H2.38128C1.98679 8.5711 1.66699 8.25131 1.66699 7.85682ZM1.66699 11.6663C1.66699 11.2719 1.98679 10.9521 2.38128 10.9521H17.6194C18.0139 10.9521 18.3337 11.2719 18.3337 11.6663C18.3337 12.0608 18.0139 12.3806 17.6194 12.3806H2.38128C1.98679 12.3806 1.66699 12.0608 1.66699 11.6663ZM1.66699 15.4759C1.66699 15.0814 1.98679 14.7616 2.38128 14.7616H17.6194C18.0139 14.7616 18.3337 15.0814 18.3337 15.4759C18.3337 15.8704 18.0139 16.1902 17.6194 16.1902H2.38128C1.98679 16.1902 1.66699 15.8704 1.66699 15.4759Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableView);
export default __webpack_public_path__ + "static/media/table-view.39a4e2d400cbc1e418d464b5d799e493.svg";
export { ForwardRef as ReactComponent };